// extracted by mini-css-extract-plugin
module.exports = {"spiderweb":"SpiderWeb_spiderweb__C62NE"};